import SimpleCardListing from '@package/components/Blocks/Listing/variations/SimpleCardListing';
import NewsCardListing from '@package/components/Blocks/Listing/variations/NewsCardListing';
import DownloadListing from '@package/components/Blocks/Listing/variations/DownloadListing';
import SearchResults from '@package/components/Blocks/Listing/variations/SearchResults';
import PhotogalleryListing from '@package/components/Blocks/Listing/variations/PhotogalleryListing';
import ProjectsCardListing from '@package/components/Blocks/Listing/variations/ProjectsCardListing';
import MapTemplate from '@package/components/Blocks/Listing/variations/MapTemplate';

import getDefaultSchema from '@package/config/Blocks/schemas/listing-variations/default-schema';
import getSimpleCardVariationSchema from '@package/config/Blocks/schemas/listing-variations/simple-card-variation-schema';
import getNewsCardVariationSchema from '@package/config/Blocks/schemas/listing-variations/news-card-variation-schema';
import getDownloadVariationSchema from '@package/config/Blocks/schemas/listing-variations/download-list-variation-schema';
import getSearchResultsVariationSchema from '@package/config/Blocks/schemas/listing-variations/search-results-variation-schema';
import getPhotogalleryVariationSchema from '@package/config/Blocks/schemas/listing-variations/photogallery-variation-schema';
import getProjectsCardVariationSchema from '@package/config/Blocks/schemas/listing-variations/projects-card-variation-schema';
import getMapVariationSchema from '@package/config/Blocks/schemas/listing-variations/map-variation-schema';

import { removeListingVariation } from '@package/config/Blocks/schemas/utils';

import divideHorizontalSVG from '@plone/volto/icons/divide-horizontal.svg';
import BreakView from '@package/components/Blocks/Break/View';
import BreakEdit from '@package/components/Blocks/Break/Edit';

import infoSVG from '@plone/volto/icons/info.svg';
import InfoboxView from '@package/components/Blocks/InfoBox/View';
import InfoboxEdit from '@package/components/Blocks/InfoBox/Edit';

import text1SVG from '@package/icons/text1.svg';
import Text1View from '@package/components/Blocks/Text1/View';
import Text1Edit from '@package/components/Blocks/Text1/Edit';

import text5SVG from '@package/icons/text5.svg';
import Text5View from '@package/components/Blocks/Text5/View';
import Text5Edit from '@package/components/Blocks/Text5/Edit';

import text4SVG from '@package/icons/text4.svg';
import Text4View from '@package/components/Blocks/Text4/View';
import Text4Edit from '@package/components/Blocks/Text4/Edit';

import text6SVG from '@package/icons/text6.svg';
import Text6View from '@package/components/Blocks/Text6/View';
import Text6Edit from '@package/components/Blocks/Text6/Edit';

import text7SVG from '@package/icons/text7.svg';
import Text7View from '@package/components/Blocks/Text7/View';
import Text7Edit from '@package/components/Blocks/Text7/Edit';

import sliderSVG from '@plone/volto/icons/slider.svg';
import SliderView from '@package/components/Blocks/Slider/View';
import SliderEdit from '@package/components/Blocks/Slider/Edit';

import numbersSVG from '@package/icons/numbers_block.svg';
import NumbersView from '@package/components/Blocks/Numbers/View';
import NumbersEdit from '@package/components/Blocks/Numbers/Edit';

import moreSVG from '@plone/volto/icons/more.svg';
import BreadcrumbsView from '@package/components/Blocks/Breadcrumbs/View';
import BreadcrumbsEdit from '@package/components/Blocks/Breadcrumbs/Edit';

import ViewHTMLBlock from '@package/components/Blocks/HTML/View';
import EditHTMLBlock from '@package/components/Blocks/HTML/Edit';

import iconsNumbersSVG from '@package/icons/icons_and_numbers.svg';
import IconsAndNumbersView from '@package/components/Blocks/IconsAndNumbers/View';
import IconsAndNumbersEdit from '@package/components/Blocks/IconsAndNumbers/Edit';

import iconsAndTextSVG from '@package/icons/icons_and_text.svg';
import IconsAndTextView from '@package/components/Blocks/IconsAndText/View';
import IconsAndTextEdit from '@package/components/Blocks/IconsAndText/Edit';

import imageColumnsSVG from '@package/icons/image_columns.svg';
import ImageColumnsView from '@package/components/Blocks/ImageColumns/View';
import ImageColumnsEdit from '@package/components/Blocks/ImageColumns/Edit';

import linkSVG from '@plone/volto/icons/link.svg';
import LinkedItemsView from '@package/components/Blocks/LinkedItems/View';
import LinkedItemsEdit from '@package/components/Blocks/LinkedItems/Edit';
import TextEdit from '@package/components/Blocks/Text/Edit';
import TextView from '@package/components/Blocks/Text/View';

import tabsSVG from '@package/icons/tabs.svg';
import TabsView from '@package/components/Blocks/Tabs/View';
import TabsEdit from '@package/components/Blocks/Tabs/Edit';

import calendarSVG from '@plone/volto/icons/calendar.svg';
import PageMetadataView from '@package/components/Blocks/PageMetadata/View';
import PageMetadataEdit from '@package/components/Blocks/PageMetadata/Edit';

import tagSVG from '@plone/volto/icons/tag.svg';
import PageTagView from '@package/components/Blocks/PageTag/View';
import PageTagEdit from '@package/components/Blocks/PageTag/Edit';

import RelatedItemsView from '@package/components/Blocks/RelatedItems/View';
import RelatedItemsEdit from '@package/components/Blocks/RelatedItems/Edit';

import downSVG from '@package/icons/arrow-down.svg';
import rightSVG from '@package/icons/arrow-right.svg';
import upSVG from '@package/icons/arrow-up.svg';

import zoomSVG from '@plone/volto/icons/zoom.svg';
import SearchProgettiEdit from '@package/components/Blocks/SearchProgetti/Edit';
import SearchProgettiView from '@package/components/Blocks/SearchProgetti/View';

export const SiteBlocks = (config) => {
  const defaultBlocksConfig = {
    restricted: false,
    mostUsed: false,
    security: {
      addPermission: [],
      view: [],
    },
    sidebarTab: 1,
  };
  config.blocks.blocksConfig = {
    ...config.blocks.blocksConfig,
    title: { ...config.blocks.blocksConfig.title, restricted: false }, //lo si può aggiungere sempre
    text: {
      ...config.blocks.blocksConfig.text,
      edit: TextEdit,
      view: TextView,
      sidebarTab: 1,
    },
    //Blocks that cannot be added manually
    breadcrumbs: {
      ...defaultBlocksConfig,
      id: 'breadcrumbs',
      title: 'Briciole di pane',
      icon: moreSVG,
      group: 'text',
      view: BreadcrumbsView,
      edit: BreadcrumbsEdit,
      restricted: true,
      sidebarTab: 1,
    },
    related_items: {
      id: 'related_items',
      title: 'Contenuti correlati',
      icon: moreSVG,
      group: 'common',
      view: RelatedItemsView,
      edit: RelatedItemsEdit,
      restricted: true,
      mostUsed: false,
      blockHasOwnFocusManagement: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },
    pagemetadata: {
      id: 'pagemetadata',
      title: 'Data di pubblicazione',
      icon: calendarSVG,
      group: 'common',
      view: PageMetadataView,
      edit: PageMetadataEdit,
      restricted: false,
      mostUsed: false,
      blockHasOwnFocusManagement: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },
    pagetag: {
      id: 'pagetag',
      title: 'Tag della Pagina',
      icon: tagSVG,
      group: 'common',
      view: PageTagView,
      edit: PageTagEdit,
      restricted: true,
      mostUsed: false,
      blockHasOwnFocusManagement: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },
    //END - Blocks that cannot be added manually

    infobox: {
      id: 'infobox',
      title: 'Box informazione',
      icon: infoSVG,
      group: 'common',
      view: InfoboxView,
      edit: InfoboxEdit,
      restricted: true,
      mostUsed: false,
      blockHasOwnFocusManagement: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },
    slider: {
      ...defaultBlocksConfig,
      id: 'slider',
      title: 'Slider',
      icon: sliderSVG,
      group: 'media',
      view: SliderView,
      edit: SliderEdit,
      sidebarTab: 1,
    },
    image_columns: {
      ...defaultBlocksConfig,
      id: 'image_columns',
      title: 'Immagini affiancate',
      icon: imageColumnsSVG,
      group: 'media',
      view: ImageColumnsView,
      edit: ImageColumnsEdit,
      sidebarTab: 1,
    },
    tabs: {
      id: 'tabs',
      title: 'Tabs',
      icon: tabsSVG,
      group: 'text',
      view: TabsView,
      edit: TabsEdit,
      restricted: false,
      mostUsed: false,
      blockHasOwnFocusManagement: true,
      sidebarTab: 1,
      security: {
        addPermission: [],
        view: [],
      },
    },
    text1: {
      ...defaultBlocksConfig,
      id: 'text1',
      title: 'Testo 1',
      icon: text1SVG,
      group: 'text',
      view: Text1View,
      edit: Text1Edit,
      blockHasOwnFocusManagement: true,
    },
    text4: {
      ...defaultBlocksConfig,
      id: 'text4',
      title: 'Testo 4',
      icon: text4SVG,
      group: 'text',
      view: Text4View,
      edit: Text4Edit,
      blockHasOwnFocusManagement: true,
    },
    text5: {
      ...defaultBlocksConfig,
      id: 'text5',
      title: 'Testo 5',
      icon: text5SVG,
      group: 'text',
      view: Text5View,
      edit: Text5Edit,
      blockHasOwnFocusManagement: true,
    },
    text6: {
      ...defaultBlocksConfig,
      id: 'text6',
      title: 'Testo 6',
      icon: text6SVG,
      group: 'text',
      view: Text6View,
      edit: Text6Edit,
      blockHasOwnFocusManagement: true,
    },
    text7: {
      ...defaultBlocksConfig,
      id: 'text7',
      title: 'Testo 7',
      icon: text7SVG,
      group: 'text',
      view: Text7View,
      edit: Text7Edit,
    },
    break: {
      ...defaultBlocksConfig,
      id: 'break',
      title: 'Interruzione di pagina',
      icon: divideHorizontalSVG,
      group: 'text',
      view: BreakView,
      edit: BreakEdit,
      sidebarTab: 0,
    },
    numbers: {
      ...defaultBlocksConfig,
      id: 'numbers',
      title: 'Numeri',
      icon: numbersSVG,
      group: 'text',
      view: NumbersView,
      edit: NumbersEdit,
      sidebarTab: 1,
    },
    icons_and_numbers: {
      ...defaultBlocksConfig,
      id: 'icons_and_numbers',
      title: 'Icone e numeri',
      icon: iconsNumbersSVG,
      group: 'text',
      view: IconsAndNumbersView,
      edit: IconsAndNumbersEdit,
      sidebarTab: 1,
    },
    icons_and_text: {
      ...defaultBlocksConfig,
      id: 'icons_and_text',
      title: 'Icone e testo',
      icon: iconsAndTextSVG,
      group: 'text',
      view: IconsAndTextView,
      edit: IconsAndTextEdit,
      sidebarTab: 1,
    },
    html: {
      ...config.blocks.blocksConfig.html,
      view: ViewHTMLBlock,
      edit: EditHTMLBlock,
      sidebarTab: 1,
    },
    accordion: {
      ...config.blocks.blocksConfig.accordion,
      group: 'text',
      titleIcons: {
        closed: { leftPosition: rightSVG, rightPosition: downSVG },
        opened: { leftPosition: downSVG, rightPosition: upSVG },
      },
    },
    linked_items: {
      ...defaultBlocksConfig,
      id: 'linked_items',
      title: 'Elementi collegati',
      icon: linkSVG,
      group: 'common',
      view: LinkedItemsView,
      edit: LinkedItemsEdit,
      sidebarTab: 1,
    },
    teaser: {
      ...config.blocks.blocksConfig.teaser,
      title: 'Anteprime',
    },
    search_progetti: {
      ...defaultBlocksConfig,
      id: 'search_progetti',
      title: 'Ricerca progetti',
      icon: zoomSVG,
      group: 'common',
      view: SearchProgettiView,
      edit: SearchProgettiEdit,
      sidebarTab: 0,
    },
    __grid: {
      ...config.blocks.blocksConfig.__grid,
      title: 'Griglia',
      gridAllowedBlocks: ['teaser', 'image', 'text', 'html'],
    },
    listing: {
      ...config.blocks.blocksConfig.listing,
      showLinkMore: true,
      getAsyncData: null, // questo disabilita il ssr dei listing perché rallenta vistosamente la pagina (per ora continuiamo con rendertron)
      variations: [
        ...config.blocks.blocksConfig.listing.variations,
        {
          id: 'simpleCardListing',
          template: SimpleCardListing,
          title: 'Simple Card',
          isDefault: true,
          schemaEnhancer: ({ schema, formData, intl }) => {
            let pos = getDefaultSchema(schema, formData, intl);
            getSimpleCardVariationSchema(schema, formData, intl, pos);
            return schema;
          },
        },
        {
          id: 'newsCardListing',
          isDefault: false,
          title: 'News Card',
          template: NewsCardListing,
          schemaEnhancer: ({ schema, formData, intl }) => {
            let pos = getDefaultSchema(schema, formData, intl);
            getNewsCardVariationSchema(schema, formData, intl, pos);
            return schema;
          },
        },
        {
          id: 'projectsCardListing',
          template: ProjectsCardListing,
          title: 'Projects Card',
          isDefault: false,
          schemaEnhancer: ({ schema, formData, intl }) => {
            let pos = getDefaultSchema(schema, formData, intl);
            getProjectsCardVariationSchema(schema, formData, intl, pos);
            return schema;
          },
        },
        {
          id: 'mapListing',
          template: MapTemplate,
          title: 'Map',
          isDefault: false,
          schemaEnhancer: ({ schema, formData, intl }) => {
            let pos = getDefaultSchema(schema, formData, intl);
            getMapVariationSchema(schema, formData, intl, pos);
            return schema;
          },
        },
        {
          id: 'photogalleryListing',
          isDefault: false,
          title: 'Photogallery',
          template: PhotogalleryListing,
          schemaEnhancer: ({ schema, formData, intl }) => {
            let pos = getDefaultSchema(schema, formData, intl);
            getPhotogalleryVariationSchema(schema, formData, intl, pos);
            return schema;
          },
        },
        {
          id: 'downloadListing',
          isDefault: false,
          title: 'Download',
          template: DownloadListing,
          schemaEnhancer: ({ schema, formData, intl }) => {
            let pos = getDefaultSchema(schema, formData, intl);
            getDownloadVariationSchema(schema, formData, intl, pos);
            return schema;
          },
        },
        {
          id: 'searchResults',
          isDefault: false,
          title: 'Search results',
          template: SearchResults,
          schemaEnhancer: ({ schema, formData, intl }) => {
            let pos = getDefaultSchema(schema, formData, intl);
            getSearchResultsVariationSchema(schema, formData, intl, pos);
            return schema;
          },
        },
        // {
        //   id: 'example-variation',
        //   isDefault: true,
        //   title: 'Example',
        //   template: ExampleVariation,
        //   schemaEnhancer: ({ schema, formData, intl }) => {
        //     let pos = getDefaultSchema(schema, formData, intl);
        //     getExampleVariationSchema(schema, formData, intl, pos);
        //     return schema;
        //   },
        // },
      ],
    },
  };

  //disable slate, use draftjs
  config.blocks.blocksConfig.table.restricted = false;
  config.blocks.blocksConfig.slateTable.restricted = true;

  removeListingVariation(config, 'default');
  removeListingVariation(config, 'imageGallery');
  removeListingVariation(config, 'summary');
  delete config.blocks.blocksConfig.toc; //remove block 'indice dei contenuti'
  delete config.blocks.blocksConfig.teaserGrid; //remove block 'teaserGrid'
  delete config.blocks.blocksConfig.imagesGrid; //remove block 'imagesGrid'

  config.blocks.requiredBlocks = ['breadcrumbs']; //il blocco 'title' non è required perchè al suo posto possono mettere il blocco slider
  config.blocks.initialBlocks = {
    ...config.blocks.initialBlocks,
    Document: ['breadcrumbs', 'title', 'related_items'],
    Event: ['breadcrumbs', 'title', 'infobox', 'related_items'],
    'News Item': ['slider', 'breadcrumbs', 'title', 'related_items'],
  };
  config.blocks.initialBlocksFocus = {
    ...config.blocks.initialBlocksFocus,
    Document: 'title',
    Event: 'title',
    'News Item': 'title',
  };
};
